// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Rx = require("../../rx/Rx.bs.js");
let Axios = require("axios");
let React = require("react");
let Sentry = require("../../Sentry.bs.js");
let Stdlib = require("@rescript/runtime/lib/js/Stdlib.js");
let V4 = require("uuid/v4");
let Upload = require("./upload").default;
let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");
let ImageUtils = require("../imageUtils/ImageUtils.bs.js");
let AuthSession = require("../../../utils/AuthSession.bs.js");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Promise = require("@rescript/runtime/lib/js/Stdlib_Promise.js");
let AttachmentsApi = require("../../../api/attachmentsApi");

function addFiles(files, t) {
  t.addFiles(files);
}

function observable(t) {
  return t.observable;
}

function make() {
  let subject = Rx.Subject.make();
  let addFiles = files => Rx.Observable.Observer.next(files, Rx.Subject.observer(subject));
  let observable = Rx.Subject.observable(subject);
  return {
    addFiles: addFiles,
    observable: observable
  };
}

let FileObserver = {
  addFiles: addFiles,
  observable: observable,
  make: make
};

function uploadFile(prim0, prim1) {
  return AttachmentsApi.uploadFile(prim0, prim1);
}

let UploadFile = {
  uploadFile: uploadFile
};

function sign(token, file) {
  let file_id = file.id;
  let file_name = file.file.name;
  let file_size = file.file.size;
  let file_type = file.file.type;
  let file$1 = {
    id: file_id,
    name: file_name,
    size: file_size,
    type: file_type
  };
  return Rx.Operators.defer(() => Rx.Observable.fromPromise(AttachmentsApi.uploadFile(token, file$1)));
}

function doUpload(prim0, prim1, prim2, prim3) {
  return Upload(prim0, prim1, prim2, prim3);
}

function upload(result, file) {
  let source = Axios.CancelToken.source();
  return Rx.Observable.fromFn(emitter => {
    Stdlib_Promise.$$catch(doUpload(result, file, source, evt => {
      if (evt.lengthComputable) {
        return Rx.Observable.Emitter.next(evt.loaded / evt.total, emitter);
      }
    }).then(() => {
      Rx.Observable.Emitter.complete(emitter);
      return Promise.resolve();
    }), err => {
      Rx.Observable.Emitter.error(err, emitter);
      return Promise.resolve();
    });
    return Rx.Unsubscriber.make(() => {
      source.cancel();
    });
  });
}

let Helpers = {
  UploadFile: UploadFile,
  sign: sign,
  doUpload: doUpload,
  upload: upload
};

function doRenderPreview(param) {
  let file = param.file;
  let onChangePreview = param.onChangePreview;
  let observable = Rx.Single.fromPromise(ImageUtils.resize(240, undefined, file.file));
  Rx.Single.subscribeFn(event => {
    if (event.TAG === "Ok") {
      return onChangePreview(file.id, event._0);
    } else {
      return Sentry.captureErrorMessage("Unexpected error rendering the preview", true, undefined, "AttachmentManager.res", 136, {
        error: event._0,
        file: {
          name: file.file.name,
          type: file.file.type,
          size: file.file.size
        }
      }, undefined, undefined);
    }
  }, observable);
  return observable;
}

function processQueue(state) {
  while (true) {
    let match = state.numRenderers < 5;
    let match$1 = state.queue;
    if (!match) {
      return;
    }
    if (match$1 === 0) {
      return;
    }
    state.queue = match$1.tl;
    state.numRenderers = state.numRenderers + 1 | 0;
    let __x = doRenderPreview(match$1.hd);
    Rx.Single.subscribeFn(param => {
      state.numRenderers = state.numRenderers - 1 | 0;
      processQueue(state);
    }, __x);
    continue;
  };
}

function renderPreview(onChangePreview, file, t) {
  t.queue = Stdlib_List.add(t.queue, {
    onChangePreview: onChangePreview,
    file: file
  });
  processQueue(t);
}

function make$1() {
  return {
    numRenderers: 0,
    queue: /* [] */0
  };
}

let RenderPreview = {
  maxRenderers: 5,
  doRenderPreview: doRenderPreview,
  processQueue: processQueue,
  renderPreview: renderPreview,
  make: make$1
};

function toFile(file) {
  return {
    id: V4(),
    file: file
  };
}

function isImageType(s) {
  return s.startsWith("image");
}

function isImage(attachment) {
  return attachment.file.type.startsWith("image");
}

let supportedMimeTypes = {
  hd: "application/msword",
  tl: {
    hd: "application/pdf",
    tl: {
      hd: "application/rtf",
      tl: {
        hd: "application/vnd.ms-excel",
        tl: {
          hd: "application/vnd.oasis.opendocument.presentation",
          tl: {
            hd: "application/vnd.oasis.opendocument.spreadsheet",
            tl: {
              hd: "application/vnd.oasis.opendocument.text",
              tl: {
                hd: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                tl: {
                  hd: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                  tl: {
                    hd: "image/gif",
                    tl: {
                      hd: "image/jpeg",
                      tl: {
                        hd: "image/png",
                        tl: {
                          hd: "image/webp",
                          tl: {
                            hd: "text/plain",
                            tl: {
                              hd: "text/rtf",
                              tl: {
                                hd: "video/mp4",
                                tl: {
                                  hd: "video/quicktime",
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

function isSupportedMimeType(mimeType) {
  return Stdlib_List.has(supportedMimeTypes, mimeType, (a, b) => a === b);
}

function isSupportedFile(attachment) {
  return isSupportedMimeType(attachment.file.type);
}

function useAttachmentManager(addFiles, onChangePreview, onUploadProgress, onSigned, onUploadComplete, onUploadError, onUnsupportedFileError) {
  let match = React.useState(() => ({
    numRenderers: 0,
    queue: /* [] */0
  }));
  let renderPreview$1 = match[0];
  let fileObserver = make();
  let session = AuthSession.use();
  let __x = fileObserver.observable;
  let fileArrays = Rx.Operators.publish(Rx.Operators.map(files => Belt_Array.map(files, toFile), __x));
  let __x$1 = Rx.Operators.flatMap(files => Rx.Operators.fromArray(files), fileArrays);
  let match$1 = Rx.Operators.partition(isSupportedFile, __x$1);
  let supportedFiles = match$1[0];
  let __x$2 = Rx.Operators.filter(isImage, supportedFiles);
  Rx.Observable.onNext(undefined, undefined, file => renderPreview(onChangePreview, file, renderPreview$1), __x$2);
  let __x$3 = Rx.Operators.toArray(match$1[1]);
  let __x$4 = Rx.Operators.filter(x => x.length !== 0, __x$3);
  Rx.Observable.onNext(undefined, undefined, onUnsupportedFileError, __x$4);
  Rx.Observable.onNext(undefined, undefined, file => {
    let tmp;
    tmp = session !== undefined && session.__typename === "AuthSession" ? session.token : Stdlib.panic("No token available, cannot upload file.");
    let __x = sign(tmp, file);
    Rx.Observable.onNext(undefined, err => onUploadError(file.id, err), result => {
      onSigned(result);
      let __x = upload(result, file.file);
      Rx.Observable.onNext(() => onUploadComplete(file.id), err => onUploadError(file.id, err), progress => onUploadProgress(file.id, progress), __x);
    }, __x);
  }, supportedFiles);
  let __x$5 = Rx.Operators.toArray(supportedFiles);
  Rx.Observable.onNext(undefined, undefined, addFiles, __x$5);
  return files => fileObserver.addFiles(files);
}

exports.FileObserver = FileObserver;
exports.Helpers = Helpers;
exports.RenderPreview = RenderPreview;
exports.toFile = toFile;
exports.isImageType = isImageType;
exports.isImage = isImage;
exports.supportedMimeTypes = supportedMimeTypes;
exports.isSupportedMimeType = isSupportedMimeType;
exports.isSupportedFile = isSupportedFile;
exports.useAttachmentManager = useAttachmentManager;
/* Rx Not a pure module */
